import {defineStore} from "pinia/dist/pinia";
import DAMService from "@/service/DAMService";
import {useLoadingStore} from "@/store/loadingStore";
export const useDAMStore = defineStore('DAMStore', {
    state() {
        return {
            DAMService: new DAMService(),
            pressMediaGalleryState: []
        }
    },
    getters: {
        pressMediaGallery() {
            return this.pressMediaGalleryState
        }
    },
    actions: {
        setPressMediaGallery(pressMediaGallery) {
            this.pressMediaGalleryState = pressMediaGallery.sort((a, b) => {
                return -1*(a.display_name).localeCompare(b.display_name)
            });
        },
        setPressKit(pressKit) {
            this.pressKit = pressKit.sort((a, b) => {
                return -1*(a.display_name).localeCompare(b.display_name)
            });
        },
        initPressMediaGallery() {
            const loadingStore = useLoadingStore()
            loadingStore.startLoading()
            this.DAMService.pressMediaGallery().then(pressMediaGallery => {
                this.setPressMediaGallery(pressMediaGallery)
                this.stopLoading()
            }).catch(() => loadingStore.resetLoading())
        },
        initPressKit() {
            const loadingStore = useLoadingStore()
            loadingStore.startLoading()
            this.DAMService.pressKit().then(pressKit => {
                this.setPressKit(pressKit)
                this.stopLoading()
            }).catch(() => loadingStore.resetLoading())
        },
        logout() {
            this.$reset()
        }
    },
    persist: {
        storage: sessionStorage
    }
})